/**
 * Expandable content.
 */

function createContentElement(html) {
  const content = document.createElement("div");
  content.innerHTML = html;
  content.className = "expandable__content";
  return content;
}

function createSeeMoreLink(text, onClick) {
  const link = document.createElement("a");
  link.href = "#";
  link.innerHTML = text;
  link.onclick = onClick;
  link.className = "expandable__see-more";
  return link;
}

export function initExpandable(expandable) {
  const shortHeight = parseFloat(
    expandable.attributes["data-expandable"].value
  );
  const seeMoreText = expandable.attributes["data-expandable-more"].value;
  const seeLessText = expandable.attributes["data-expandable-less"].value;
  const fullHeight = expandable.getBoundingClientRect().height;

  if (fullHeight > shortHeight) {
    expandable.classList.add("expandable");

    const content = createContentElement(expandable.innerHTML);
    const link = createSeeMoreLink(seeMoreText, (event) => {
      event.preventDefault();
      expandable.classList.toggle(
        "expandable--expanded",
        !content.style.height
      );
      if (!content.style.height) {
        content.style.height = fullHeight + "px";
        link.innerHTML = seeLessText;
      } else {
        content.style.height = null;
        link.innerHTML = seeMoreText;
      }
      link.blur();
    });
    expandable.innerHTML = "";
    expandable.appendChild(content);
    expandable.appendChild(link);
  }
}

export default function initExpandables(base) {
  const expandables = (base || document).querySelectorAll("[data-expandable]");

  expandables.forEach(initExpandable);
}
